export default api => {
	return {

		auth: {
			validateToken: `${api}/api/auth/validate-token`,
			signup: `${api}/api/auth/signup`,
			login: `${api}/api/auth/login`,
			getUser: `${api}/api/auth/get-user`,
			forgotPassword: `${api}/api/auth/forgot-password`,
			resetPassword: `${api}/api/auth/reset-password`,
		},

		app: {
			boot: `${api}/api/boot/admin/init`,
			temp: `${api}/api/app/temp`,
		},

		settings: {
			constants: `${api}/api/settings/constants`,
			metaDataConstants: `${api}/api/settings/meta-data-constants`,
			testEmail: `${api}/api/settings/test-email`,
		},

		cms: {
			pages: `${api}/api/cms/pages`,
			popups: `${api}/api/cms/popups`,
			navigation: `${api}/api/cms/navigation`,
			articles: `${api}/api/cms/articles`,
			articleAsset: `${api}/api/cms/articles/assets`,
			pageAsset: `${api}/api/cms/pos/pages/assets`,
			popupAsset: `${api}/api/cms/popups/assets`,
			tmpSlot: `${api}/api/cms/slot`,
			assets: `${api}/api/cms/assets`,
			contacts: `${api}/api/cms/contacts`,
			users: `${api}/api/cms/users`,
			projectIcons: `${api}/api/cms/project-icons`,
			permissions: `${api}/api/cms/permissions`,
			document: {
				getURI: `${api}/api/cms/document/get-uri`,
			},
			siteSettings: `${api}/api/cms/site-settings`,
			seo: `${api}/api/cms/meta-data`,
			slot: `${api}/api/cms/common/slot`,
		},

		pos: {
			altTag: `${api}/api/cms/pos/alt-tag`,
			pages: `${api}/api/cms/pos/pages`,
		},

		ppc: {
			altTag: `${api}/api/cms/ppc/alt-tag`,
			faq: `${api}/api/cms/ppc/faq`,
			forms: `${api}/api/cms/ppc/forms`,
			page: `${api}/api/cms/ppc/page`,
			pageComponent: `${api}/api/cms/ppc/page-component`,
			construxHomeSlider: `${api}/api/cms/ppc/construx-home-slider`,
			// componentDetails: `${api}/api/cms/ppc/component-details`,
			// sectionDetails: `${api}/api/cms/ppc/section-details`,
			productCategory: `${api}/api/cms/ppc/product-category`,
			product: `${api}/api/cms/ppc/product`,
			serviceCategory: `${api}/api/cms/ppc/service-category`,
			service: `${api}/api/cms/ppc/service`,
			associations: `${api}/api/cms/ppc/associations`,
			clients: `${api}/api/cms/ppc/clients`,
			contactPersons: `${api}/api/cms/ppc/contact-persons`,
			location: `${api}/api/cms/ppc/location`,
			testimonials: `${api}/api/cms/ppc/testimonials`,
			// calendar: `${api}/api/cms/ppc/calendar`,
		},

		dashboard: {
			lastArticles: `${api}/api/dashboard/last-articles`,
			lastUsers: `${api}/api/dashboard/last-users`,
		},

		assetViewer: {
			index: `${api}/api/cms/asset-viewer/index`,
		},
	};
};
